import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import {
  autoUpdate,
  flip,
  offset,
  shift,
  useFloating,
  FloatingArrow,
  arrow
} from "@floating-ui/react";
import { Container, TooltipStyled } from "./Tooltip.styled";
import { randomID } from "../../../utils/randomID";

export const Tooltip = ({
  label,
  children,
  bgColor = "#444",
  color = "white",
  width = "fit-content",
  enabled = true,
  styles = {},
  containerStyles = {}
}) => {
  const [ID] = useState(randomID);
  const arrowRef = useRef(null);
  const [hovering, setHovering] = useState(false);
  const { refs, strategy, x, y, context } = useFloating({
    middleware: [
      offset(5),
      flip(),
      shift(),
      arrow({
        element: arrowRef
      })
    ],
    whileElementsMounted: autoUpdate
  });

  useEffect(() => {
    const onKeyDown = ({ code }) => {
      if (code === "Escape") setHovering(false);
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);

  const labelDiv = (
    <TooltipStyled
      id={ID}
      role="tooltip"
      ref={refs.setFloating}
      color={color}
      bgColor={bgColor}
      width={width}
      style={{ position: strategy, top: y ?? 0, left: x ?? 0, zIndex: 101, ...styles }}
    >
      {label}
      <FloatingArrow ref={arrowRef} context={context} fill={bgColor} />
    </TooltipStyled>
  );

  return (
    <>
      {createPortal(enabled && hovering && labelDiv, document.body)}
      <Container
        aria-describedby={ID}
        ref={refs.setReference}
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        onFocus={() => setHovering(true)}
        onBlur={() => setHovering(false)}
        style={containerStyles}
      >
        {children}
      </Container>
    </>
  );
};
